import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { SessionComponentCanDeactivate } from './sessioncomponent-can-deactivate';

@Injectable()
export class CanSessionDeactivateGuard implements CanDeactivate<SessionComponentCanDeactivate> {
  canDeactivate(component: SessionComponentCanDeactivate): boolean {
    // if (!component.canDeactivate()) {

      // if (confirm("Are you sure you want to leave this page? You will lose all information.")) {
      //     return true;
      // } else {
      //     return false;
      // }
    // }
    return true;
  }
}
